import script from "./SystemView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SystemView.vue?vue&type=script&setup=true&lang=ts"

import "./SystemView.vue?vue&type=style&index=0&id=ca75a9f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca75a9f6"]])

export default __exports__